import React, { useState, useEffect } from 'react';
import '../styles/Services.css';
import { BsAirplaneFill } from "react-icons/bs";
import { GiGraduateCap } from "react-icons/gi";
import { FaHelmetSafety } from "react-icons/fa6";
import { MdOutlineModelTraining } from "react-icons/md";
import { FaMoneyCheckAlt, FaLanguage, FaTimes } from "react-icons/fa";
import { Link } from 'react-router-dom';

function Services() {
    const [selectedService, setSelectedService] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (service) => {
        setSelectedService(service);
        setIsModalOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedService(null);
        document.body.style.overflow = 'auto';
    };

    const priorityService = {
        icon: <FaLanguage id='icon' />,
        title: "IELTS & TOEFL PREPARATION",
        description: "Prepare for international English proficiency exams with expert guidance.",
        details: (
            <>
                <div className="priority-tag">UPCOMING CLASS</div>
                <div className="detail-row">
                    <span className="detail-label">Start Date</span>
                    <span className="detail-value">May 1st, 2026</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Time</span>
                    <span className="detail-value">6pm - 8pm</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Schedule</span>
                    <span className="detail-value">4 days/week for 1 month</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Location</span>
                    <span className="detail-value">Google Meet (Online)</span>
                </div>
            </>
        ),
        priority: true
    };

    const services = [
        {
            icon: <BsAirplaneFill id='icon' />,
            title: "Visa Advisory",
            shortDesc: "Are you looking to travel to a foreign country but are unsure of the VISA requirements? We provide comprehensive advisory services.",
            details: (
                <>
                    <p>Are you looking to travel to a foreign country but are unsure of the VISA requirements? Do you need help with the entire process from start to finish? We provide comprehensive advisory services to ensure you have all the necessary documents and meet all the requirements for a successful VISA application.</p>
                    <p>Our assistance includes:</p>
                    <ul>
                        <li>Document review and preparation</li>
                        <li>Application form assistance</li>
                        <li>Interview preparation</li>
                        <li>Follow-up with embassies and consulates</li>
                        <li>Visa status tracking</li>
                        <li>Advice on supporting documents</li>
                        <li>Financial document verification</li>
                        <li>Travel itinerary assistance</li>
                    </ul>
                </>
            )
        },
        {
            icon: <GiGraduateCap id='icon' />,
            title: "Student Recruitment",
            shortDesc: "Applying to universities can be a daunting task. We assist students in finding and applying to universities that match their goals.",
            details: (
                <>
                    <p>Applying to universities can be a daunting task. It's important to find the right school for yourself based on your academic background and career goals. We assist students in finding and applying to universities that match their academic and career goals.</p>
                    <p>Our services include:</p>
                    <ul>
                        <li>University selection guidance</li>
                        <li>Application processing</li>
                        <li>Document review and preparation</li>
                        <li>Personal statement review</li>
                        <li>Recommendation letter assistance</li>
                        <li>Interview preparation</li>
                        <li>Scholarship application assistance</li>
                        <li>Visa guidance for students</li>
                    </ul>
                </>
            )
        },
        {
            icon: <FaHelmetSafety id='icon' />,
            title: "Job Placement",
            shortDesc: "Our job placement services connect employers with qualified candidates from around the globe.",
            details: (
                <>
                    <p>Imagine being able to find the best talent from all over the world and have them relocated to your destination seamlessly. Our job placement services connect employers with qualified candidates from around the globe.</p>
                    <p>We handle the recruitment process, including:</p>
                    <ul>
                        <li>Candidate screening and vetting</li>
                        <li>Interview coordination</li>
                        <li>Relocation assistance</li>
                        <li>Work permit processing</li>
                        <li>Job market analysis</li>
                        <li>Resume optimization</li>
                        <li>Background verification</li>
                        <li>Post-arrival support</li>
                    </ul>
                </>
            )
        },
        {
            icon: <MdOutlineModelTraining id='icon' />,
            title: "Training & Workshops",
            shortDesc: "We offer training programs and workshops designed to enhance the skills and knowledge of your workforce.",
            details: (
                <>
                    <p>Are you planning on developing your workforce? Perhaps through trainings and workshops that can help enhance their skills and productivity? We offer a variety of training programs and workshops designed to enhance the skills and knowledge of your workforce.</p>
                    <p>Our programs include:</p>
                    <ul>
                        <li>Custom training programs</li>
                        <li>Professional development courses</li>
                        <li>Leadership workshops</li>
                        <li>Industry certifications</li>
                        <li>Soft skills training</li>
                        <li>Technical skills workshops</li>
                        <li>Team building programs</li>
                        <li>Remote learning options</li>
                    </ul>
                </>
            )
        },
        {
            icon: <FaMoneyCheckAlt id='icon' />,
            title: "Educational Loans",
            shortDesc: "Many Malawians dream of studying abroad but struggle with financing. We have partnered with international financiers.",
            details: (
                <>
                    <p>Many Malawians dream of studying abroad but struggle with financing. We have partnered with international financing giants to provide educational loans that make studying abroad more accessible. Our loan programs offer flexible repayment options and competitive interest rates.</p>
                    <p><strong>These loans are designed for postgraduate studies and cover:</strong></p>
                    <ul>
                        <li>Tuition fees</li>
                        <li>Airfare (round trip)</li>
                        <li>Living expenses</li>
                        <li>Accommodation</li>
                        <li>Food and groceries</li>
                        <li>Transportation</li>
                        <li>Course materials</li>
                        <li>Health insurance</li>
                        <li>Student visa fee</li>
                    </ul>
                    <p><strong>Loan features:</strong></p>
                    <ul>
                        <li>Competitive interest rates</li>
                        <li>Flexible repayment plans</li>
                        <li>Grace period after studies</li>
                        <li>Quick approval process</li>
                        <li>No collateral required</li>
                    </ul>
                </>
            )
        }
    ];

    return (
        <section className="services-section" id="services">
            <h2 className="services-title">Our Services</h2>
            <p className="services-subtitle">Comprehensive solutions for your international aspirations</p>
            
            <div className="services-layout">
                {/* Priority Card */}
                <Link to="/classes" className="priority-card">
                    <div className="priority-card-content">
                        <div className="priority-card-header">
                            {priorityService.icon}
                            <span className="priority-label">FEATURED</span>
                        </div>
                        <h3>{priorityService.title}</h3>
                        <p>{priorityService.description}</p>
                        <div className="priority-details">
                            {priorityService.details}
                        </div>
                    </div>
                </Link>
                
                {/* Service Cards Grid */}
                <div className="services-masonry">
                    {services.map((service, index) => (
                        <div 
                            key={index} 
                            className="service-card-masonry"
                            onClick={() => openModal(service)}
                        >
                            <div className="service-card-inner">
                                <div className="service-card-header">
                                    {service.icon}
                                </div>
                                <h4>{service.title}</h4>
                                <p>{service.shortDesc}</p>
                                <button className="read-more-btn">Read More</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal Popup */}
            {isModalOpen && selectedService && (
                <div className="service-modal-overlay" onClick={closeModal}>
                    <div className="service-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>
                            <FaTimes />
                        </button>
                        <div className="modal-header">
                            {selectedService.icon}
                            <h3>{selectedService.title}</h3>
                        </div>
                        <div className="modal-body">
                            {selectedService.details}
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

export default Services;